<template>
  <!-- 아래 요소 높이 일정해야 함 -->
  <div class="payment__content--box" v-if="orderCheckYn == true">
    <div class="payment__top--type2">
      <!-- <span class="ft--lg">{{ $t('User.OrderCheck.msg5') }}</span> -->
      <!-- <span class="tit">{{ $t('User.OrderCheck.msg6') }}</span> -->
      {{ $t('User.OrderCheck.msg6') }}
    </div>

    <!-- header -->
    <div class="payment__header">
      <div class="lyr-title">{{ $t('User.OrderCheck.msg8') }}</div>
      <div class="ft-point">{{ $t('User.OrderCheck.msg9') }}</div>
      <div class="lyr-txt">{{ $t('User.OrderCheck.msg10') }}</div>
    </div>
    <!-- //header -->

    <!-- 스크롤 영역 -->
    <div class="table-area scroll-area" id="orderScroll">
      <table class="tb-hdr-fix order-chk">
        <thead>
          <tr>
            <th :style="['background-color: #f2f2f280;']">{{ $t('User.OrderCheck.msg11') }}</th>
            <th :style="['background-color: #f2f2f280;']">{{ $t('User.OrderCheck.msg12') }}</th>
            <th :style="['background-color: #f2f2f280;']">{{ isSimpleToken === false ? '' : $t('User.OrderCheck.msg13') }}</th>
            <th :style="['background-color: #f2f2f280;']">{{ $t('User.OrderCheck.msg14') }}</th>
          </tr>
        </thead>
        <tbody>
          <template v-for="item in baskets.ITEMLIST">
            <tr>
              <td>{{ item.ITEM_NM }}</td>
              <td>{{ item.SALES_QTY }}</td>
              <td :style="[isSimpleToken === false ? 'visibility : hidden' : '']">{{ item.VAT_RATE }}%</td>
              <td>{{ $displayUprc(item.TOTAL_UPRC) }}</td>
            </tr>
            <tr :key="opt" v-for="opt in item.OPTIONITEM" class="detail">
              <td colspan="4">{{ opt.ITEM_PARENT_NM }} / {{ opt.ITEM_NM }}</td>
            </tr>
          </template>
        </tbody>
      </table>
    </div>
    <!-- //스크롤 영역 -->

    <div class="btn-area">
      <button class="btn-arr-u btn-anim" @mouseup="scrollMove(-50)">위로</button>
      <button class="btn-arr-d btn-anim" @mouseup="scrollMove(+50)">아래로</button>
    </div>

    <div class="lst-order">
      <dl>
        <dt class="order-check">{{ $t('User.OrderCheck.msg15') }}</dt>
        <dd class="order-check">{{ baskets.HEADER.ORDER_QTY }}</dd>
      </dl>
      <dl>
        <dt class="order-check">{{ $t('User.OrderCheck.msg16') }}</dt>
        <dd class="order-check">{{ $displayUprc(baskets.HEADER.TOT_DC_AMT) }}</dd>
      </dl>
      <dl>
        <dt class="order-check">{{ $t('User.OrderCheck.msg18') }}</dt>
        <dd class="ft--3xlg ft--point ft--bold">{{ $displayUprc(baskets.HEADER.SALES_AMT) }}</dd>
      </dl>
    </div>

    <div class="layer__button">
      <button
        class="btn btn--cancel btn-anim"
        @mouseup="
          this.$router.go(-1);
          $logInfo(`Return Order Page`);
        "
      >
        {{ $t('User.OrderCheck.msg19') }}
      </button>
      <button class="btn btn--submit btn-anim" @mouseup="$emit('setOrder')">{{ $t('User.OrderCheck.msg20') }}</button>
    </div>
  </div>
  <!-- //payment__content -->
</template>

<script>
import audioHelper from '@/js/common/audioHelper.js';

export default {
  name: 'orderCheck',
  props: {
    orderCheckYn: Boolean,
  },
  methods: {
    scrollMove(moveY) {
      var scroll = document.getElementById('orderScroll');
      scroll.scrollTop += moveY;
    },
  },
  data() {
    return {
      darkModeYn: this.$store.getters.getDarkModeYn,
      baskets: this.$store.getters.getBaskets,
      currUnitText: this.$store.getters.getCurrUnitText,
      isSimpleToken: this.$store.getters.getIsSimpleToken,
    };
  },
  mounted() {
    this.$changeDarkMode(this.darkModeYn);
    this.$showButtonAnimation();
  },
  updated() {
    this.$showButtonAnimation();
  },
  components: {},
  computed: {
    darkMode: function () {
      return this.$store.getters.getDarkModeYn;
    },
  },
  watch: {
    darkMode() {
      this.darkModeYn = this.darkModeYn ? false : true;

      this.$changeDarkMode(this.darkModeYn);
    },
    orderCheckYn: function (val) {
      try {
        // 20230407 HSSHIN Audio 재생
        if (val) {
          audioHelper.playAudio('00110', this.$i18n.locale, this.$store.getters.getPosConfig.posConfig.useVoiceSupport);
        } else {
          audioHelper.stopAudio();
        }
      } catch (ex) {
        console.error(ex);
      }
    },
  },
};
</script>

<style src="@/assets/css/user/common.css" scoped></style>
<style src="@/assets/css/user/pages/payment.css" scoped></style>
<style src="@/assets/css/user/pages/touchbox.css" scoped></style>
<style src="@/assets/css/user/pages/table.css" scoped></style>
<style src="@/assets/css/user/dark/common-dark.css" scoped></style>
<style src="@/assets/css/user/dark/payment-dark.css" scoped></style>
.
<style src="@/assets/css/user/dark/touchbox-dark.css" scoped></style>
<style scoped></style>
